import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import FormulaireSelectionProjet from '../../../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import FormulaireSelectionDateHeureUnix from '../../../../Graphe/ProfilGraphe/FormulaireGraphe/FormulaireSelectionDateHeureUnix/FormulaireSelectionDateHeureUnix';

import AttenteRequete from '../../../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import { glossaire_alarm_level } from '../../../../../ressources/glossaires/glossaire_niveau_alarme';
import * as requestType from '../../../../../ressources/glossaires/glossaire_requetes';
import * as actions from '../../../../../services/actions';

import { RiMailSendFill } from 'react-icons/all';
import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireGabarit.module.scss';

const FormulaireGabarit = (props) => {
  const [formulaireGabarit, setFormulaireGabarit] = useState({
    project_id: null,
    selected_project_id: null,
    template_name: '',
    start: null,
    end: null,
    private: 0,
    alarm_level: 2,
    template: '',
    template_id: undefined,
  });

  useEffect(() => {
    if (props.preconfigurerGabarit !== undefined) {
      setFormulaireGabarit({
        ...props.preconfigurerGabarit,
        template: JSON.stringify(props.preconfigurerGabarit.template),
      });
    }
  }, [props.preconfigurerGabarit]);

  const gererEtatDeCibleName = (event) =>
    setFormulaireGabarit({
      ...formulaireGabarit,
      [event.target.name]: event.target.value,
    });

  const gererTemplate = (event) =>
    setFormulaireGabarit({
      ...formulaireGabarit,
      template: event.target.value,
    });

  const gererProjetId = (projetId) =>
    setFormulaireGabarit({
      ...formulaireGabarit,
      project_id: projetId,
      selected_project_id: projetId,
    });

  const gererDebut_time_interval = (unix) =>
    setFormulaireGabarit({
      ...formulaireGabarit,
      start: unix,
    });

  const gererFin_time_interval = (unix) =>
    setFormulaireGabarit({
      ...formulaireGabarit,
      end: unix,
    });

  const reqEnvoi = () => {
    /**
     * envoie la requête de création ou modification de gabarit
     * @type {{template_name: (string|*), list_emails: ([]|*), project_id: number}}
     */
    try {
      let formulaireGabaritForRequest = {
        //création de l'objet à envoyer
        project_id: parseInt(formulaireGabarit.project_id),
        template_name: formulaireGabarit.template_name,
        template_id: formulaireGabarit.template_id,
        start: formulaireGabarit.start,
        end: formulaireGabarit.end,
        private: parseInt(formulaireGabarit.private),
        alarm_level: parseInt(formulaireGabarit.alarm_level),
        template: JSON.parse(formulaireGabarit.template),
      };

      if (formulaireGabaritForRequest.template_id === undefined) {
        props.reqAjouter(formulaireGabaritForRequest);
      } else {
        props.reqModifier(formulaireGabaritForRequest);
      }
    } catch (e) {
      console.error('invalide template json', e);
    }
  };
  /*
   */
  return (
    <>
      <div className={[styles.ConteneurInfo].join(' ')}>
        <div
          className={[
            s.container,
            s.border,
            s.text_left,
            styles.Formulaire,
          ].join(' ')}
        >
          <div>
            <div className="radio">
              <label
                onClick={() =>
                  setFormulaireGabarit({
                    ...formulaireGabarit,
                    project_id: null,
                  })
                }
              >
                <input type="radio" checked={!formulaireGabarit.project_id} />
                {checkMot('acces_libre')}
              </label>
            </div>
            <div className="radio">
              <label
                onClick={() =>
                  setFormulaireGabarit({
                    ...formulaireGabarit,
                    project_id: formulaireGabarit.selected_project_id,
                  })
                }
              >
                <input type="radio" checked={formulaireGabarit.project_id} />
                <FormulaireSelectionProjet
                  affichageProfil={props.affichageProfil}
                  gererProjetId={gererProjetId}
                  preconfigurerProjetId={formulaireGabarit.project_id}
                />
                {/**FIN project_id**/}
              </label>
            </div>
          </div>
          <div className={s.form_group}>
            <label
              className={[styles.label].join(' ')}
              htmlFor="inlineFormCustomSelect"
            >
              {checkMot('template_name')}
            </label>
            <div className={[s.form_row, s.align_items_center].join(' ')}>
              <div className={s.col_12}>
                <input
                  type="text"
                  pattern="[0-9a-zA-Z._%+-\\s ]+"
                  className={[s.form_control, s.mb_2].join(' ')}
                  name="template_name"
                  placeholder="template_name"
                  value={formulaireGabarit.template_name}
                  disabled={props.affichageProfil}
                  onChange={(event) => gererEtatDeCibleName(event)}
                />
              </div>
            </div>
          </div>
          {/**template_name**/}

          <div className={s.form_group}>
            {/**DEBUT time_interval**/}
            <div className={[s.form_row, s.align_items_center].join(' ')}>
              <span className={s.col_12}>
                {checkMot(
                  "Interval de temps sur lequel le gabarit s'applique [début, fin]"
                )}
              </span>
              <div className={s.col_6}>
                <FormulaireSelectionDateHeureUnix
                  value={formulaireGabarit.start}
                  gereUnixDate={gererDebut_time_interval}
                  disabled={props.affichageProfil}
                />
              </div>
              <div className={s.col_6}>
                <FormulaireSelectionDateHeureUnix
                  value={formulaireGabarit.end}
                  gereUnixDate={gererFin_time_interval}
                  disabled={props.affichageProfil}
                />
              </div>
            </div>
          </div>
          {/**FIN time_interval**/}

          {/**DEBUT private**/}
          <div className={[s.form_row, styles.heder].join(' ')}>
            <div className={s.col_12}>
              <label className={styles.stil2}>{checkMot('acces_prive')}</label>
              <select
                onChange={(event) => gererEtatDeCibleName(event)}
                name="private"
                defaultValue={formulaireGabarit.private}
                disabled={props.affichageProfil}
                value={formulaireGabarit.private}
                className={[s.custom_select, styles.stile].join(' ')}
              >
                <option value={1}>{checkMot('prive')}</option>
                <option value={0}>{checkMot('publique')}</option>
              </select>
            </div>
          </div>
          {/**FIN private**/}
          {/**DEBUT alarm_level**/}
          <div className={[s.form_row, styles.heder].join(' ')}>
            <div className={s.col_12}>
              <label className={styles.stil2}>{checkMot('alarm_level')}</label>
              <select
                onChange={(event) => gererEtatDeCibleName(event)}
                name="alarm_level"
                defaultValue={formulaireGabarit.alarm_level}
                disabled={props.affichageProfil}
                value={formulaireGabarit.alarm_level}
                className={[s.custom_select, styles.stile].join(' ')}
              >
                {Object.keys(glossaire_alarm_level)
                  .filter((key) => parseInt(key) !== 9)
                  .map((key) => (
                    <option key={key} value={key}>
                      {checkMot(glossaire_alarm_level[key])}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          {/**FIN alarm_level**/}
          <div className={[s.form_row, styles.heder].join(' ')}>
            <label className={styles.stil2}>{checkMot('template')}</label>
            <textarea
              className={[s.form_control, styles.textarea].join(' ')}
              placeholder={checkMot('template')}
              name={'template'}
              value={formulaireGabarit.template}
              disabled={props.affichageProfil}
              onChange={(event) => gererTemplate(event)}
            />
          </div>
          {/**FIN template**/}
          {!props.affichageProfil ? (
            props.preconfigurerGabarit !== undefined ? (
              <>
                <AttenteRequete
                  request_type={requestType.modifier_un_gabarit}
                  str={checkMot('modification_en_cours')}
                >
                  <button className={styles.btF} onClick={reqEnvoi}>
                    <RiMailSendFill size={24} />{' '}
                    {checkMot('envoi_modification')}
                  </button>
                </AttenteRequete>
              </>
            ) : (
              <>
                <AttenteRequete
                  request_type={requestType.creer_un_gabarit}
                  str={checkMot('creation_en_cours')}
                >
                  <button className={styles.btF} onClick={reqEnvoi}>
                    <RiMailSendFill size={24} /> {checkMot('envoi_creation')}
                  </button>
                </AttenteRequete>
              </>
            )
          ) : null}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    reqAjouter: (formulaireGabarit) =>
      dispatch(actions.reqCreerGabarit(formulaireGabarit)),
    reqModifier: (idGabarit) => dispatch(actions.reqModifierGabarit(idGabarit)),
  };
};

export default connect(null, mapDispatchToProps)(FormulaireGabarit);
